import type { ButtonHTMLAttributes } from 'react';
import { forwardRef } from 'react';

import styled from 'styled-components';

const StyledButton = styled.button`
  background-color: transparent;
  border: none;
  &:focus {
    box-shadow: none;
  }

  cursor: pointer;
  box-sizing: border-box;
`;

export const TransparentButton = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  (props, ref) => <StyledButton type={props.type ?? 'button'} {...props} ref={ref} />
);
